import * as actionTypes from './actionTypes';
import { logoutService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';

const isClient = isClientEnv();

const fetchLogoutRequest = () => ({
  type: actionTypes.FETCH_LOGOUT_REQUEST
});

const fetchLogoutFailure = () => ({
  type: actionTypes.FETCH_LOGOUT_FAILURE
});

const fetchLogoutSuccess = () => ({
  type: actionTypes.FETCH_LOGOUT_SUCCESS
});

export const setLogoutValue = (value: boolean) => ({
  type: actionTypes.SET_LOGOUT_VALUE,
  value
});

const clearLocalStorage = () => {
  let user = JSON.parse(localStorage.getItem('user'));
  delete user.jwt;
  delete user.email;
  delete user.data;
  user.isLogin = false;
  localStorage.setItem('user', JSON.stringify(user));
};

export const fetchLogout = (json, tokenJWT) => {
  return async dispatch => {
    dispatch(fetchLogoutRequest());
    try {
      const data = await logoutService.post(json, tokenJWT);
      if (data.error) {
        dispatch(fetchLogoutFailure());
        if (data.code === 400) {
          dispatch(actionsModalError.openModalError(data.message));
          if (isClient) {
            clearLocalStorage();
          }
        }
      } else {
        dispatch(fetchLogoutSuccess(data));
        if (isClient) {
          clearLocalStorage();
        }
      }
    } catch (error) {
      console.log(error, 'error')
      dispatch(actionsModalError.openModalError());
      dispatch(fetchLogoutFailure());
      if (isClient) {
        clearLocalStorage();
      }
    }
  }
}
